"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Event = void 0;

var Event =
/** @class */
function () {
  function Event() {}

  Event.prototype.CIOMarketingEventCountType = function () {
    return [{
      slug: 'fewer-than-5',
      name: 'Fewer than 5',
      description: null,
      isFewerThanFive: true,
      isMoreThanThirty: false,
      isBetweenFiveAndThirty: false
    }, {
      slug: 'between-5-and-30',
      name: 'Between 5 and 30',
      description: null,
      isFewerThanFive: false,
      isMoreThanThirty: false,
      isBetweenFiveAndThirty: true
    }, {
      slug: 'more-than-30',
      name: 'More than 30',
      description: null,
      isFewerThanFive: false,
      isMoreThanThirty: true,
      isBetweenFiveAndThirty: false
    }];
  };

  Event.prototype.CIOMarketingEventType = function () {
    return [{
      slug: 'brand-awareness-events',
      name: 'Brand Awareness Events',
      description: null,
      isBrandAwarenessEvents: true,
      isTradeShows: false,
      isConferences: false,
      isRoadshows: false,
      isInternalMeetings: false,
      isRecruitingEvents: false,
      isFundraisingEvents: false
    }, {
      slug: 'trade-shows',
      name: 'Trade Shows',
      description: null,
      isBrandAwarenessEvents: false,
      isTradeShows: true,
      isConferences: false,
      isRoadshows: false,
      isInternalMeetings: false,
      isRecruitingEvents: false,
      isFundraisingEvents: false
    }, {
      slug: 'conferences',
      name: 'Conferences',
      description: null,
      isBrandAwarenessEvents: false,
      isTradeShows: false,
      isConferences: true,
      isRoadshows: false,
      isInternalMeetings: false,
      isRecruitingEvents: false,
      isFundraisingEvents: false
    }, {
      slug: 'roadshows',
      name: 'Roadshows',
      description: null,
      isBrandAwarenessEvents: false,
      isTradeShows: false,
      isConferences: false,
      isRoadshows: true,
      isInternalMeetings: false,
      isRecruitingEvents: false,
      isFundraisingEvents: false
    }, {
      slug: 'internal-meetings',
      name: 'Internal Meetings',
      description: null,
      isBrandAwarenessEvents: false,
      isTradeShows: false,
      isConferences: false,
      isRoadshows: false,
      isInternalMeetings: true,
      isRecruitingEvents: false,
      isFundraisingEvents: false
    }, {
      slug: 'recruiting-events',
      name: 'Recruiting Events',
      description: null,
      isBrandAwarenessEvents: false,
      isTradeShows: false,
      isConferences: false,
      isRoadshows: false,
      isInternalMeetings: false,
      isRecruitingEvents: true,
      isFundraisingEvents: false
    }, {
      slug: 'fundraising-events',
      name: 'Fundraising Events',
      description: null,
      isBrandAwarenessEvents: false,
      isTradeShows: false,
      isConferences: false,
      isRoadshows: false,
      isInternalMeetings: false,
      isRecruitingEvents: false,
      isFundraisingEvents: true
    }];
  };

  Event.prototype.CIOMarketingIndustryType = function () {
    return [{
      slug: 'consumer-goods',
      name: 'Consumer Goods',
      description: null,
      isAgency: false,
      isEducation: false,
      isFinance: false,
      isSportsAndEntertainment: false,
      isTechnology: false,
      isOther: false
    }, {
      slug: 'agency',
      name: 'Agency',
      description: null,
      isAgency: true,
      isEducation: false,
      isFinance: false,
      isSportsAndEntertainment: false,
      isTechnology: false,
      isOther: false
    }, {
      slug: 'education',
      name: 'Education',
      description: null,
      isAgency: false,
      isEducation: true,
      isFinance: false,
      isSportsAndEntertainment: false,
      isTechnology: false,
      isOther: false
    }, {
      slug: 'finance',
      name: 'Finance',
      description: null,
      isAgency: false,
      isEducation: false,
      isFinance: true,
      isSportsAndEntertainment: false,
      isTechnology: false,
      isOther: false
    }, {
      slug: 'sports-and-entertainment',
      name: 'Sports and Entertainment',
      description: null,
      isAgency: false,
      isEducation: false,
      isFinance: false,
      isSportsAndEntertainment: true,
      isTechnology: false,
      isOther: false
    }, {
      slug: 'technology',
      name: 'Technology',
      description: null,
      isAgency: false,
      isEducation: false,
      isFinance: false,
      isSportsAndEntertainment: false,
      isTechnology: true,
      isOther: false
    }, {
      slug: 'other',
      name: 'Other',
      description: null,
      isAgency: false,
      isEducation: false,
      isFinance: false,
      isSportsAndEntertainment: false,
      isTechnology: false,
      isOther: true
    }];
  };

  Event.prototype.CalendarType = function () {
    return [{
      slug: 'ical',
      name: 'iCal',
      description: null,
      isICal: true,
      isGoogle: false,
      isYahoo: false
    }, {
      slug: 'google',
      name: 'Google',
      description: null,
      isICal: false,
      isGoogle: true,
      isYahoo: false
    }, {
      slug: 'yahoo',
      name: 'Yahoo',
      description: null,
      isICal: false,
      isGoogle: false,
      isYahoo: true
    }];
  };

  Event.prototype.EventDateFilterType = function () {
    return [{
      slug: 'current-future',
      name: 'Current &amp; Future Events',
      description: 'This will show you all your future and current events.',
      isCurrentFuture: true,
      isPastAll: false,
      isPast3Months: false,
      isPast3MonthsAndFuture: false,
      isPast6Months: false
    }, {
      slug: 'past-all',
      name: 'All Past Events',
      description: null,
      isCurrentFuture: false,
      isPastAll: true,
      isPast3Months: false,
      isPast3MonthsAndFuture: false,
      isPast6Months: false
    }, {
      slug: 'past-3-months',
      name: 'Past 3 Months',
      description: null,
      isCurrentFuture: false,
      isPastAll: false,
      isPast3Months: true,
      isPast3MonthsAndFuture: false,
      isPast6Months: false
    }, {
      slug: 'past-3-months-and-future',
      name: 'Past 3 Months and Future Events',
      description: 'This will show you past 3 months events and all future events',
      isCurrentFuture: false,
      isPastAll: false,
      isPast3Months: false,
      isPast3MonthsAndFuture: true,
      isPast6Months: false
    }, {
      slug: 'past-6-months',
      name: 'Past 6 Months',
      description: null,
      isCurrentFuture: false,
      isPastAll: false,
      isPast3Months: false,
      isPast3MonthsAndFuture: false,
      isPast6Months: true
    }];
  };

  Event.prototype.EventMessageSlugType = function () {
    return [{
      slug: '{{eventPublicUrl}}',
      name: 'Event Public URL',
      description: null,
      isEventPublicURL: true,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventName}}',
      name: 'Event Name',
      description: null,
      isEventPublicURL: false,
      isEventName: true,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventEmail}}',
      name: 'Event Email',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: true,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventLocationName}}',
      name: 'Event Location Name',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: true,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventLocationAddress}}',
      name: 'Event Location Address',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: true,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventLocationDetails}}',
      name: 'Event Location Details',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: true,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventDescription}}',
      name: 'Event Description',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: true,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventFacebook}}',
      name: 'Event Facebook',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: true,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventTwitter}}',
      name: 'Event Twitter',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: true,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventInstagram}}',
      name: 'Event Instagram',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: true,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventStartDateTime}}',
      name: 'Event Start Date - Time',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: true,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventStartDate}}',
      name: 'Event Start Date',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: true,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventStartTime}}',
      name: 'Event Start Time',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: true,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventStartDateTimeShort}}',
      name: 'Event Start Date - Time (Short)',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: true,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventStartDateShort}}',
      name: 'Event Start Date (Short)',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: true,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventStartDateShort}}',
      name: 'Event Start Date (Short)',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: true,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventStartDateTimeLong}}',
      name: 'Event Start Date - Time (Long)',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: true,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventStartDateLong}}',
      name: 'Event Start Date (Long)',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: true,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventStartTimeLong}}',
      name: 'Event Start Time (Long)',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: true,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventEndDateTime}}',
      name: 'Event End Date - Time',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: true,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventEndDate}}',
      name: 'Event End Date',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: true,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventEndTime}}',
      name: 'Event End Time',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: true,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventEndDateTimeShort}}',
      name: 'Event End Date - Time (Short)',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: true,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventEndDateShort}}',
      name: 'Event End Date (Short)',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: true,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventEndTimeShort}}',
      name: 'Event End Time (Short)',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: true,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventEndDateTimeLong}}',
      name: 'Event End Date - Time (Long)',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: true,
      isEventEndDateLong: false,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventEndDateLong}}',
      name: 'Event End Date (Long)',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: true,
      isEventEndTimeLong: false
    }, {
      slug: '{{eventEndTimeLong}}',
      name: 'Event End Time (Long)',
      description: null,
      isEventPublicURL: false,
      isEventName: false,
      isEventEmail: false,
      isEventLocationName: false,
      isEventLocationAddress: false,
      isEventLocationDetails: false,
      isEventDescription: false,
      isEventFacebook: false,
      isEventTwitter: false,
      isEventInstagram: false,
      isEventStartDateTime: false,
      isEventStartDate: false,
      isEventStartTime: false,
      isEventStartDateTimeShort: false,
      isEventStartDateShort: false,
      isEventStartTimeShort: false,
      isEventStartDateTimeLong: false,
      isEventStartDateLong: false,
      isEventStartTimeLong: false,
      isEventEndDateTime: false,
      isEventEndDate: false,
      isEventEndTime: false,
      isEventEndDateTimeShort: false,
      isEventEndDateShort: false,
      isEventEndTimeShort: false,
      isEventEndDateTimeLong: false,
      isEventEndDateLong: false,
      isEventEndTimeLong: true
    }];
  };

  Event.prototype.EventMessageType = function () {
    return [{
      slug: 'additional_invitation',
      name: 'Invitation Introduction',
      description: 'Displayed to guests at the beginning of the RSVP process.',
      isIntroductionRegistration: false,
      isConfirmationRegistration: false,
      isWaitListConfirmationRegistration: false,
      isIntroductionInvitation: true,
      isConfirmationInvitation: false,
      isDeclinationInvitation: false,
      isWaitListConfirmationInvitation: false,
      isOpening: false,
      isClosing: false,
      isSoldOut: false,
      isReveal: false,
      isDisclaimer: false,
      isResponseRestriction: false,
      isWaitListSMS: false,
      defaultValue: '&lt;p style=&quot;text-align: center; font-size: 48px; font-family: Helvetica, sans-serif; color: inherit; line-height:1; margin-bottom: 12px&quot;&gt;RSVP&lt;/p&gt;&lt;p style=&quot;text-align: center; font-size: 16px; font-family: Helvetica, sans-serif; color: inherit; line-height:1;&quot;&gt;for&lt;/p&gt;&lt;p style=&quot;text-align: center; font-size: 24px; font-family: Helvetica, sans-serif; color: inherit; line-height:2;&quot;&gt;{{guestFirst}} {{guestLast}}&lt;/p&gt;',
      value: null
    }, {
      slug: 'confirmation_invitation',
      name: 'Invitation Confirmation',
      description: 'Displayed on the confirmation screen after a successful RSVP.',
      isIntroductionRegistration: false,
      isConfirmationRegistration: false,
      isWaitListConfirmationRegistration: false,
      isIntroductionInvitation: false,
      isConfirmationInvitation: true,
      isDeclinationInvitation: false,
      isWaitListConfirmationInvitation: false,
      isOpening: false,
      isClosing: false,
      isSoldOut: false,
      isReveal: false,
      isDisclaimer: false,
      isResponseRestriction: false,
      isWaitListSMS: false,
      defaultValue: '&lt;p style=&quot;text-align: center; font-size: 30px; font-family: Helvetica, sans-serif; color: inherit; line-height:1; padding-bottom:24px;&quot;&gt;{{guestFirst}}, you&amp;#39;re on the list!&lt;/p&gt;&lt;p style=&quot;text-align: center; font-size: 16px; font-family: Helvetica, sans-serif; color: inherit;&quot;&gt;We look forward to having you join us {{eventStartDateLong}}.&lt;/p&gt;',
      value: null
    }, {
      slug: 'declination',
      name: 'Invitation Declination',
      description: 'Displayed on the confirmation screen after a guest declines their RSVP.',
      isIntroductionRegistration: false,
      isConfirmationRegistration: false,
      isWaitListConfirmationRegistration: false,
      isIntroductionInvitation: false,
      isConfirmationInvitation: false,
      isDeclinationInvitation: true,
      isWaitListConfirmationInvitation: false,
      isOpening: false,
      isClosing: false,
      isSoldOut: false,
      isReveal: false,
      isDisclaimer: false,
      isResponseRestriction: false,
      isWaitListSMS: false,
      defaultValue: '&lt;p style=&quot;text-align: center; font-size: 30px; font-family: Helvetica, sans-serif; color: inherit; line-height:1; padding-bottom:24px;&quot;&gt;{{guestFirst}}, thanks for letting us know.&lt;/p&gt;&lt;p style=&quot;text-align: center; font-size: 16px; font-family: Helvetica, sans-serif; color: inherit;&quot;&gt;We hope to see you at our next event!&lt;/p&gt;',
      value: null
    }, {
      slug: 'wait_list_confirmation_invitation',
      name: 'Invitation Waitlisted',
      description: 'Displayed as a part of the waitlist confirmation screen after a user has been added to the waitlist, by way of either the registration or RSVP process.',
      isIntroductionRegistration: false,
      isConfirmationRegistration: false,
      isWaitListConfirmationRegistration: false,
      isIntroductionInvitation: false,
      isConfirmationInvitation: false,
      isDeclinationInvitation: false,
      isWaitListConfirmationInvitation: true,
      isOpening: false,
      isClosing: false,
      isSoldOut: false,
      isReveal: false,
      isDisclaimer: false,
      isResponseRestriction: false,
      isWaitListSMS: false,
      defaultValue: '&lt;p style=&quot;text-align: center; font-size: 30px; font-family: Helvetica, sans-serif; color: inherit; line-height:1; padding-bottom:24px;&quot;&gt;{{guestFirst}}, you&amp;#39;re on the waitlist!&lt;/p&gt;&lt;p style=&quot;text-align: center; font-size: 16px; font-family: Helvetica, sans-serif; color: inherit;&quot;&gt;We will notify you soon if spots become available.&lt;/p&gt;',
      value: null
    }, {
      slug: 'additional',
      name: 'Registration Introduction',
      description: 'Displayed to guests at the beginning of the purchase or registration process.',
      isIntroductionRegistration: true,
      isConfirmationRegistration: false,
      isWaitListConfirmationRegistration: false,
      isIntroductionInvitation: false,
      isConfirmationInvitation: false,
      isDeclinationInvitation: false,
      isWaitListConfirmationInvitation: false,
      isOpening: false,
      isClosing: false,
      isSoldOut: false,
      isReveal: false,
      isDisclaimer: false,
      isResponseRestriction: false,
      isWaitListSMS: false,
      defaultValue: null,
      value: null
    }, {
      slug: 'confirmation',
      name: 'Registration Confirmation',
      description: 'Displayed on the confirmation screen after a successful purchase or registration.',
      isIntroductionRegistration: false,
      isConfirmationRegistration: true,
      isWaitListConfirmationRegistration: false,
      isIntroductionInvitation: false,
      isConfirmationInvitation: false,
      isDeclinationInvitation: false,
      isWaitListConfirmationInvitation: false,
      isOpening: false,
      isClosing: false,
      isSoldOut: false,
      isReveal: false,
      isDisclaimer: false,
      isResponseRestriction: false,
      isWaitListSMS: false,
      defaultValue: '&lt;h1&gt;See you there&lt;/h1&gt;&lt;p&gt;{{guestFirst}} {{guestLast}} you are on the list!&lt;/p&gt;&lt;p&gt;You&#039;re all set. We look forward to seeing you soon!&lt;/p&gt;',
      value: null
    }, {
      slug: 'wait_list_confirmation',
      name: 'Registration Waitlisted',
      description: 'Displayed as a part of the waitlist confirmation screen after a user has been added to the waitlist, by way of either the registration or RSVP process.',
      isIntroductionRegistration: false,
      isConfirmationRegistration: false,
      isWaitListConfirmationRegistration: true,
      isIntroductionInvitation: false,
      isConfirmationInvitation: false,
      isDeclinationInvitation: false,
      isWaitListConfirmationInvitation: false,
      isOpening: false,
      isClosing: false,
      isSoldOut: false,
      isReveal: false,
      isDisclaimer: false,
      isResponseRestriction: false,
      isWaitListSMS: false,
      defaultValue: '&lt;h1&gt;Waitlisted&lt;/h1&gt;&lt;p&gt;{{guestFirst}} {{guestLast}} you will be notified if space opens up!&lt;/p&gt;',
      value: null
    }, {
      slug: 'soldout',
      name: 'Registration Sold-Out',
      description: 'Displayed for any event access type (General Admission, VIP, etc.) that is either sold out or at capacity.',
      isIntroductionRegistration: false,
      isConfirmationRegistration: false,
      isWaitListConfirmationRegistration: false,
      isIntroductionInvitation: false,
      isConfirmationInvitation: false,
      isDeclinationInvitation: false,
      isWaitListConfirmationInvitation: false,
      isOpening: false,
      isClosing: false,
      isSoldOut: true,
      isReveal: false,
      isDisclaimer: false,
      isResponseRestriction: false,
      isWaitListSMS: false,
      defaultValue: '&lt;p style=&quot;text-align: center; font-size: 16px; font-family: Helvetica, sans-serif; color: inherit;&quot;&gt;Tickets for {{eventName}} are no longer available through this website. Please check with the event organizers to find out if tickets are available elsewhere.&lt;/p&gt;',
      value: null
    }, {
      slug: 'opening',
      name: 'Prior To Opening',
      description: 'Displayed as a placeholder for the registration or purchase form before the event goes live and tickets become available.',
      isIntroductionRegistration: false,
      isConfirmationRegistration: false,
      isWaitListConfirmationRegistration: false,
      isIntroductionInvitation: false,
      isConfirmationInvitation: false,
      isDeclinationInvitation: false,
      isWaitListConfirmationInvitation: false,
      isOpening: true,
      isClosing: false,
      isSoldOut: false,
      isReveal: false,
      isDisclaimer: false,
      isResponseRestriction: false,
      isWaitListSMS: false,
      defaultValue: '&lt;p style=&quot;text-align: center; font-size: 16px; font-family: Helvetica, sans-serif; color: inherit;&quot;&gt;{{eventName}} is not yet available through this website.  Please check back in the near future for further updates and availability.&lt;/p&gt;',
      value: null
    }, {
      slug: 'closing',
      name: 'After Closing',
      description: 'Displayed as a placeholder for the registration or purchase form once registration has closed for an event.',
      isIntroductionRegistration: false,
      isConfirmationRegistration: false,
      isWaitListConfirmationRegistration: false,
      isIntroductionInvitation: false,
      isConfirmationInvitation: false,
      isDeclinationInvitation: false,
      isWaitListConfirmationInvitation: false,
      isOpening: false,
      isClosing: true,
      isSoldOut: false,
      isReveal: false,
      isDisclaimer: false,
      isResponseRestriction: false,
      isWaitListSMS: false,
      defaultValue: '&lt;p style=&quot;text-align: center; font-size: 16px; font-family: Helvetica, sans-serif; color: inherit;&quot;&gt;Registration for {{eventName}} has closed.&lt;/p&gt;',
      value: null
    }, {
      slug: 'disclaimer',
      name: 'Disclaimer',
      description: 'If you have created a Waiver question, this message will display as part of the purchase, registration, and RSVP process. The guest must check the disclaimer box to complete registration.',
      isIntroductionRegistration: false,
      isConfirmationRegistration: false,
      isWaitListConfirmationRegistration: false,
      isIntroductionInvitation: false,
      isConfirmationInvitation: false,
      isDeclinationInvitation: false,
      isWaitListConfirmationInvitation: false,
      isOpening: false,
      isClosing: false,
      isSoldOut: false,
      isReveal: false,
      isDisclaimer: true,
      isResponseRestriction: false,
      isWaitListSMS: false,
      defaultValue: null,
      value: null
    }, {
      slug: 'response_restriction',
      name: 'Response Restriction',
      description: 'If Editable RSVP Responses is toggled OFF, then this message will display for any registered guest who clicks the invitation link again.',
      isIntroductionRegistration: false,
      isConfirmationRegistration: false,
      isWaitListConfirmationRegistration: false,
      isIntroductionInvitation: false,
      isConfirmationInvitation: false,
      isDeclinationInvitation: false,
      isWaitListConfirmationInvitation: false,
      isOpening: false,
      isClosing: false,
      isSoldOut: false,
      isReveal: false,
      isDisclaimer: false,
      isResponseRestriction: true,
      isWaitListSMS: false,
      defaultValue: null,
      value: null
    }, {
      slug: 'reveal',
      name: 'Reveal',
      description: 'If Invitation Reveal is toggled ON, then this message will display when a guest searches for their invitation.',
      isIntroductionRegistration: false,
      isConfirmationRegistration: false,
      isWaitListConfirmationRegistration: false,
      isIntroductionInvitation: false,
      isConfirmationInvitation: false,
      isDeclinationInvitation: false,
      isWaitListConfirmationInvitation: false,
      isOpening: false,
      isClosing: false,
      isSoldOut: false,
      isReveal: true,
      isDisclaimer: false,
      isResponseRestriction: false,
      isWaitListSMS: false,
      defaultValue: null,
      value: null
    }, {
      slug: 'wait_list_sms',
      name: 'Wait List SMS',
      description: 'This sms will be sent to the attendee once they are promoted off the event waitlist.',
      isIntroductionRegistration: false,
      isConfirmationRegistration: false,
      isWaitListConfirmationRegistration: false,
      isIntroductionInvitation: false,
      isConfirmationInvitation: false,
      isDeclinationInvitation: false,
      isWaitListConfirmationInvitation: false,
      isOpening: false,
      isClosing: false,
      isSoldOut: false,
      isReveal: false,
      isDisclaimer: false,
      isResponseRestriction: false,
      isWaitListSMS: true,
      defaultValue: 'You’re off the waitlist! You are confirmed for [event_name]',
      value: null
    }];
  };

  Event.prototype.EventStateType = function () {
    return [{
      slug: 'published',
      name: 'Published',
      description: null,
      isPublished: true,
      isDraft: false,
      isArchived: false
    }, {
      slug: 'draft',
      name: 'Draft',
      description: null,
      isPublished: false,
      isDraft: true,
      isArchived: false
    }, {
      slug: 'archived',
      name: 'Archived',
      description: null,
      isPublished: false,
      isDraft: false,
      isArchived: true
    }];
  };

  Event.prototype.EventType = function () {
    return [{
      slug: 'in-person',
      name: 'In-Person',
      description: null,
      isInPerson: true,
      isVirtual: false,
      isHybrid: false,
      isOther: false
    }, {
      slug: 'virtual',
      name: 'Virtual',
      description: null,
      isInPerson: false,
      isVirtual: true,
      isHybrid: false,
      isOther: false
    }, {
      slug: 'hybrid',
      name: 'Hybrid',
      description: null,
      isInPerson: false,
      isVirtual: false,
      isHybrid: true,
      isOther: false
    }, {
      slug: 'other',
      name: 'Other',
      description: null,
      isInPerson: false,
      isVirtual: false,
      isHybrid: false,
      isOther: true
    }];
  };

  Event.prototype.LocationType = function () {
    return [{
      slug: 'physical',
      name: 'physical',
      description: null,
      isPhysical: true,
      isVirbela: false,
      isVirtual: false,
      isOther: false
    }, {
      slug: 'virbela',
      name: 'virbela',
      description: null,
      isPhysical: false,
      isVirbela: true,
      isVirtual: false,
      isOther: false
    }, {
      slug: 'virtual',
      name: 'virtual',
      description: null,
      isPhysical: false,
      isVirbela: false,
      isVirtual: true,
      isOther: false
    }, {
      slug: 'other',
      name: 'other',
      description: null,
      isPhysical: false,
      isVirbela: false,
      isVirtual: false,
      isOther: true
    }];
  };

  Event.prototype.MapSourceType = function () {
    return [{
      slug: 'google',
      name: 'Google',
      description: 'Google Maps',
      isGoogle: true,
      isYahoo: false,
      isBing: false
    }, {
      slug: 'yahoo',
      name: 'Yahoo',
      description: 'Yahoo Maps',
      isGoogle: false,
      isYahoo: true,
      isBing: false
    }, {
      slug: 'bing',
      name: 'Bing',
      description: 'Bing Maps',
      isGoogle: false,
      isYahoo: false,
      isBing: true
    }];
  };

  Event.prototype.PaymentProcessorType = function () {
    return [{
      slug: 'STRIPE',
      name: 'STRIPE',
      description: 'STRIPE',
      isStripe: true,
      isPaypal: false,
      isAuthorizeNet: false,
      isSpreedly: false
    }, {
      slug: 'PAYPAL',
      name: 'PAYPAL',
      description: 'PAYPAL',
      isStripe: false,
      isPaypal: true,
      isAuthorizeNet: false,
      isSpreedly: false
    }, {
      slug: 'AUTHORIZENET',
      name: 'AUTHORIZENET',
      description: 'AUTHORIZENET',
      isStripe: false,
      isPaypal: false,
      isAuthorizeNet: true,
      isSpreedly: false
    }, {
      slug: 'SPREEDLY',
      name: 'SPREEDLY',
      description: 'SPREEDLY',
      isStripe: false,
      isPaypal: false,
      isAuthorizeNet: false,
      isSpreedly: true
    }];
  };

  Event.prototype.ProcessingCurrencyType = function () {
    return [{
      slug: 'aud',
      name: 'Australia Dollar',
      description: '$',
      isAUD: true,
      isBRL: false,
      isGBP: false,
      isCAD: false,
      isDKK: false,
      isEUR: false,
      isILS: false,
      isJPY: false,
      isMXN: false,
      isNZD: false,
      isPHP: false,
      isRUB: false,
      isSEK: false,
      isCHF: false,
      isTHB: false,
      isUSD: false
    }, {
      slug: 'brl',
      name: 'Brazil Real',
      description: 'R$',
      isAUD: false,
      isBRL: true,
      isGBP: false,
      isCAD: false,
      isDKK: false,
      isEUR: false,
      isILS: false,
      isJPY: false,
      isMXN: false,
      isNZD: false,
      isPHP: false,
      isRUB: false,
      isSEK: false,
      isCHF: false,
      isTHB: false,
      isUSD: false
    }, {
      slug: 'gbp',
      name: 'United Kingdom Pound',
      description: '£',
      isAUD: false,
      isBRL: false,
      isGBP: true,
      isCAD: false,
      isDKK: false,
      isEUR: false,
      isILS: false,
      isJPY: false,
      isMXN: false,
      isNZD: false,
      isPHP: false,
      isRUB: false,
      isSEK: false,
      isCHF: false,
      isTHB: false,
      isUSD: false
    }, {
      slug: 'cad',
      name: 'Canada Dollar',
      description: '$',
      isAUD: false,
      isBRL: false,
      isGBP: false,
      isCAD: true,
      isDKK: false,
      isEUR: false,
      isILS: false,
      isJPY: false,
      isMXN: false,
      isNZD: false,
      isPHP: false,
      isRUB: false,
      isSEK: false,
      isCHF: false,
      isTHB: false,
      isUSD: false
    }, {
      slug: 'dkk',
      name: 'Denmark Krone',
      description: 'kr',
      isAUD: false,
      isBRL: false,
      isGBP: false,
      isCAD: false,
      isDKK: true,
      isEUR: false,
      isILS: false,
      isJPY: false,
      isMXN: false,
      isNZD: false,
      isPHP: false,
      isRUB: false,
      isSEK: false,
      isCHF: false,
      isTHB: false,
      isUSD: false
    }, {
      slug: 'eur',
      name: 'Euro Member Countries',
      description: '€',
      isAUD: false,
      isBRL: false,
      isGBP: false,
      isCAD: false,
      isDKK: false,
      isEUR: true,
      isILS: false,
      isJPY: false,
      isMXN: false,
      isNZD: false,
      isPHP: false,
      isRUB: false,
      isSEK: false,
      isCHF: false,
      isTHB: false,
      isUSD: false
    }, {
      slug: 'ils',
      name: 'Israel Shekel',
      description: '₪',
      isAUD: false,
      isBRL: false,
      isGBP: false,
      isCAD: false,
      isDKK: false,
      isEUR: false,
      isILS: true,
      isJPY: false,
      isMXN: false,
      isNZD: false,
      isPHP: false,
      isRUB: false,
      isSEK: false,
      isCHF: false,
      isTHB: false,
      isUSD: false
    }, {
      slug: 'jpy',
      name: 'Japan Yen',
      description: '¥',
      isAUD: false,
      isBRL: false,
      isGBP: false,
      isCAD: false,
      isDKK: false,
      isEUR: false,
      isILS: false,
      isJPY: true,
      isMXN: false,
      isNZD: false,
      isPHP: false,
      isRUB: false,
      isSEK: false,
      isCHF: false,
      isTHB: false,
      isUSD: false
    }, {
      slug: 'mxn',
      name: 'Mexico Peso',
      description: '$',
      isAUD: false,
      isBRL: false,
      isGBP: false,
      isCAD: false,
      isDKK: false,
      isEUR: false,
      isILS: false,
      isJPY: false,
      isMXN: true,
      isNZD: false,
      isPHP: false,
      isRUB: false,
      isSEK: false,
      isCHF: false,
      isTHB: false,
      isUSD: false
    }, {
      slug: 'nzd',
      name: 'New Zealand Dollar',
      description: '$',
      isAUD: false,
      isBRL: false,
      isGBP: false,
      isCAD: false,
      isDKK: false,
      isEUR: false,
      isILS: false,
      isJPY: false,
      isMXN: false,
      isNZD: true,
      isPHP: false,
      isRUB: false,
      isSEK: false,
      isCHF: false,
      isTHB: false,
      isUSD: false
    }, {
      slug: 'php',
      name: 'Philippines Peso',
      description: '₱',
      isAUD: false,
      isBRL: false,
      isGBP: false,
      isCAD: false,
      isDKK: false,
      isEUR: false,
      isILS: false,
      isJPY: false,
      isMXN: false,
      isNZD: false,
      isPHP: true,
      isRUB: false,
      isSEK: false,
      isCHF: false,
      isTHB: false,
      isUSD: false
    }, {
      slug: 'rub',
      name: 'Russia Ruble',
      description: '₽',
      isAUD: false,
      isBRL: false,
      isGBP: false,
      isCAD: false,
      isDKK: false,
      isEUR: false,
      isILS: false,
      isJPY: false,
      isMXN: false,
      isNZD: false,
      isPHP: false,
      isRUB: true,
      isSEK: false,
      isCHF: false,
      isTHB: false,
      isUSD: false
    }, {
      slug: 'sek',
      name: 'Sweden Krona',
      description: 'kr',
      isAUD: false,
      isBRL: false,
      isGBP: false,
      isCAD: false,
      isDKK: false,
      isEUR: false,
      isILS: false,
      isJPY: false,
      isMXN: false,
      isNZD: false,
      isPHP: false,
      isRUB: false,
      isSEK: true,
      isCHF: false,
      isTHB: false,
      isUSD: false
    }, {
      slug: 'chf',
      name: 'Switzerland Franc',
      description: 'CHF',
      isAUD: false,
      isBRL: false,
      isGBP: false,
      isCAD: false,
      isDKK: false,
      isEUR: false,
      isILS: false,
      isJPY: false,
      isMXN: false,
      isNZD: false,
      isPHP: false,
      isRUB: false,
      isSEK: false,
      isCHF: true,
      isTHB: false,
      isUSD: false
    }, {
      slug: 'thb',
      name: 'Thailand Baht',
      description: '฿',
      isAUD: false,
      isBRL: false,
      isGBP: false,
      isCAD: false,
      isDKK: false,
      isEUR: false,
      isILS: false,
      isJPY: false,
      isMXN: false,
      isNZD: false,
      isPHP: false,
      isRUB: false,
      isSEK: false,
      isCHF: false,
      isTHB: true,
      isUSD: false
    }, {
      slug: 'usd',
      name: 'United States Dollar',
      description: '$',
      isAUD: false,
      isBRL: false,
      isGBP: false,
      isCAD: false,
      isDKK: false,
      isEUR: false,
      isILS: false,
      isJPY: false,
      isMXN: false,
      isNZD: false,
      isPHP: false,
      isRUB: false,
      isSEK: false,
      isCHF: false,
      isTHB: false,
      isUSD: true
    }];
  };

  Event.prototype.ThemeColorType = function () {
    return [{
      slug: 'alert',
      name: 'Alert Color',
      description: '#df260a',
      isAlert: true,
      isBackground: false,
      isFont: false,
      isPrimary: false,
      isPrimaryAlt: false
    }, {
      slug: 'background',
      name: 'Background Color',
      description: '#ffffff',
      isAlert: false,
      isBackground: true,
      isFont: false,
      isPrimary: false,
      isPrimaryAlt: false
    }, {
      slug: 'font',
      name: 'Font Color',
      description: '#444444',
      isAlert: false,
      isBackground: false,
      isFont: true,
      isPrimary: false,
      isPrimaryAlt: false
    }, {
      slug: 'primary',
      name: 'Primary Color',
      description: '#5085F0',
      isAlert: false,
      isBackground: false,
      isFont: false,
      isPrimary: true,
      isPrimaryAlt: false
    }, {
      slug: 'primaryAlt',
      name: 'Secondary Color',
      description: '#ffffff',
      isAlert: false,
      isBackground: false,
      isFont: false,
      isPrimary: false,
      isPrimaryAlt: true
    }];
  };

  Event.prototype.ThemeFontFamilyType = function () {
    return [{
      slug: 'times',
      name: 'Times New Roman',
      description: null,
      isTimes: true
    }];
  };

  Event.prototype.ThemeNameType = function () {
    return [{
      slug: 'material',
      name: 'Material Design',
      description: null,
      isMaterial: true
    }];
  };

  Event.prototype.TrackingScriptType = function () {
    return [{
      slug: 'registration_tracking_script',
      name: 'Registration Tracking Script',
      description: 'Provide the tracking script for your analytics tool, such as Google Analytics, to collect data on visitors to the registration form.',
      isRegistration: true,
      isConfirmation: false,
      value: null
    }, {
      slug: 'confirmation_tracking_script',
      name: 'Confirmation Tracking Script',
      description: 'Provide the tracking script for your analytics tool, such as Google Analytics, to collect data on visitors to the confirmation page.',
      isRegistration: false,
      isConfirmation: true,
      value: null
    }];
  };

  Event.prototype.VariantType = function () {
    return [{
      slug: 'full',
      name: 'Full',
      description: null,
      isFull: true,
      isCio: false,
      isLite: false,
      isSession: false,
      isPanel: false,
      isKeynote: false,
      isBlock: false,
      isSample: false,
      isAnySessionType: false
    }, {
      slug: 'cio',
      name: 'Check-in-Only',
      description: null,
      isFull: false,
      isCio: true,
      isLite: false,
      isSession: false,
      isPanel: false,
      isKeynote: false,
      isBlock: false,
      isSample: false,
      isAnySessionType: false
    }, {
      slug: 'lite',
      name: 'Lite',
      description: null,
      isFull: false,
      isCio: false,
      isLite: true,
      isSession: false,
      isPanel: false,
      isKeynote: false,
      isBlock: false,
      isSample: false,
      isAnySessionType: false
    }, {
      slug: 'session',
      name: 'Session',
      description: null,
      isFull: false,
      isCio: false,
      isLite: false,
      isSession: true,
      isPanel: false,
      isKeynote: false,
      isBlock: false,
      isSample: false,
      isAnySessionType: true
    }, {
      slug: 'panel',
      name: 'Panel',
      description: null,
      isFull: false,
      isCio: false,
      isLite: false,
      isSession: false,
      isPanel: true,
      isKeynote: false,
      isBlock: false,
      isSample: false,
      isAnySessionType: true
    }, {
      slug: 'keynote',
      name: 'Keynote',
      description: null,
      isFull: false,
      isCio: false,
      isLite: false,
      isSession: false,
      isPanel: false,
      isKeynote: true,
      isBlock: false,
      isSample: false,
      isAnySessionType: true
    }, {
      slug: 'block',
      name: 'Block',
      description: null,
      isFull: false,
      isCio: false,
      isLite: false,
      isSession: false,
      isPanel: false,
      isKeynote: false,
      isBlock: true,
      isSample: false,
      isAnySessionType: true
    }, {
      slug: 'sample',
      name: 'Sample',
      description: null,
      isFull: false,
      isCio: false,
      isLite: false,
      isSession: false,
      isPanel: false,
      isKeynote: false,
      isBlock: false,
      isSample: true,
      isAnySessionType: false
    }];
  };

  return Event;
}();

exports.Event = Event;